import React, { useEffect } from "react";
import { useParams } from "react-router";

import {
  Box,
  Grid,
  Typography,
  IconButton,
  Tooltip,
  useTheme
} from "@mui/material";

import FeatureErrorBoundary from "../../atoms/FeatureErrorBoundary";
import Link from "../../atoms/mui/Link";

import {
  settingsPages,
  useSettingsPages
} from "../../../helpers/components/settings";
import { analyticsPage } from "../../../helpers/analytics";
import usePlatformLayoutContext from "../../../helpers/contexts/platformLayout";

const SettingsNavIcon = ({ isActive, label, href, icon }) => {
  const { palette } = useTheme();
  const { rootPath } = usePlatformLayoutContext();

  return (
    <Grid item>
      <Tooltip title={label}>
        <span>
          <Link href={`${rootPath}/settings/${href}`}>
            <IconButton
              style={{
                color: palette.text.primary,
                opacity: isActive ? 1 : 0.7
              }}
              size="large"
            >
              {icon}
            </IconButton>
          </Link>
        </span>
      </Tooltip>
    </Grid>
  );
};

const Settings = () => {
  const { palette } = useTheme();

  const { view, action } = useParams();
  const visibleSettingsPages = useSettingsPages();

  const { Component, label } =
    settingsPages.find(({ href }) => href === view) || {};

  useEffect(() => {
    analyticsPage("settings");
  }, []);

  return (
    <FeatureErrorBoundary featureName="Settings">
      <Box display="flex" flexDirection="column" style={{ minHeight: "100%" }}>
        <Box
          p={2}
          style={{
            backgroundColor: palette.backgroundGray.dark
          }}
        >
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <Typography variant="h2" color="inherit">
                {`Settings- ${label}`}
              </Typography>
            </Grid>
            <Grid item>
              <Grid container alignItems="center">
                {visibleSettingsPages.map((settingsPageObj, idx) => (
                  <SettingsNavIcon
                    key={`settings-nav-icon-${idx}`}
                    {...settingsPageObj}
                    isActive={view === settingsPageObj.href}
                  />
                ))}
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <Box
          flexGrow={1}
          p={2}
          style={{ backgroundColor: palette.backgroundGray.main }}
        >
          <Component action={action} />
        </Box>
      </Box>
    </FeatureErrorBoundary>
  );
};
export default Settings;
